import React from "react";

import {
  ChannelType,
  DeviceType,
  StatSigViewType,
  VisitorType,
} from "@intelligems/ig-types";
import { DeviceRadio } from "@src/components/AudienceFilters/Device/DeviceRadio";

import { Device } from "../../../components/AudienceFilters/Device/Device";

interface DeviceTypeFilterProps {
  onStringFilterChange: (
    newValue: DeviceType | VisitorType | ChannelType | StatSigViewType,
    filterKey: "statSigView" | "deviceType" | "channelType" | "visitorType"
  ) => void;
  deviceType?: DeviceType | null;
}

export const DeviceTypeFilter = ({
  deviceType,
  onStringFilterChange,
}: DeviceTypeFilterProps) => {
  return (
    <DeviceRadio
      deviceType={deviceType || "any"}
      onClick={onStringFilterChange}
    />
  );
};
